module.exports = __webpack_public_path__ + "cancellara-dist/img/pragma-comunicazione.04254434.png";